// extracted by mini-css-extract-plugin
export default {"component":"IncodeShareAuthorisationLink-module__component-T48m"};